import React from 'react'
import PageHeader from '../components/sidebar/PageHeader'
import DashboardBase from '../components/tablero/DashboardBase'
import CardGridMap from '../components/tablero/CardGridMap'

const Tablero = () => {
  return (
    <div className='w-full'>
      <PageHeader pageTitle="Tablero" />
      <DashboardBase />
    </div>
  )
}

export default Tablero
